<style>
</style>
<template>
<div>
  <div>{{ value.customerName }}</div>
  <div>{{ !!value.idKey ? 'IČ: ' + value.idKey : '' }}</div>
  <div>{{ !!value.countryId ? 'DIČ: ' + value.countryId : '' }}</div>
</div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {}
}
</script>
